
import { defineComponent, PropType } from 'vue'
import { Repository } from '~/types/types'

/**
 * Component to add CTA to activate repository with pending .toml commit (adhoc run)
 */
export default defineComponent({
  name: 'ActivateRepoCta',

  props: {
    repository: {
      type: Object as PropType<Repository>,
      required: true
    }
  },

  data() {
    return {
      isActivationModalOpen: false
    }
  }
})
